/* John Crocket Size Advisor v1.7 (2026-09-01) - vanilla JS, keine Abhaengigkeiten.
   Aktivierung pro Produkt ueber das Metafeld custom.size_advisor_family.

   v1.6: Auf der EN-Locale nennt der Berater Groessen dual ("36R (EU 46)"),
   passend zum UK/US-Umschalter im Variant-Picker (01.09.2026). Gerechnet,
   gespeichert und uebernommen wird IMMER die DE-Konfektionsgroesse; die
   Konvertierung ist reine Anzeige (displaySize). Laengen-Buckets auf 23-31
   synchronisiert (Picker-Fix 01.09.).

   v1.7: Inch-Eingabe und -Anzeige auf EN (Niels-Go 01.09.). cm/in-Umschalter
   im Formular; Default folgt dem Picker-Toggle (UK/US -> in). Koerpergroesse
   im Inch-Modus als ft+in-Doppelfeld. Die gesamte Logik (recommend,
   Plausibilitaet, Tabellen, Profil-Speicherung) bleibt cm - Inch existiert
   NUR an der Eingabe- und Anzeige-Grenze (leseWerteCm/schreibeFormWerte/
   fmt-Helper, Copy-Keys mit Suffix _in). Messmethode unveraendert Flachmass;
   die Inch-Plausibilitaetstexte fangen die Umfang-Verwechslung ab.

   Ablauf:
     1. Beim Laden nur Trigger-Label setzen (Copy dafuer kommt inline aus dem Snippet).
        Die grosse Config wird NICHT auf dem kritischen Pfad geladen.
     2. Beim ersten Klick auf den Trigger: Config nachladen, Formular bauen, Panel oeffnen.
     3. Submit -> Empfehlung rechnen -> Verfuegbarkeit gegen das Varianten-JSON pruefen.
     4. "Groesse uebernehmen" -> Variant-Picker vorbelegen.

   Persistenz: localStorage pro Family, NUR mit Opt-in-Checkbox (default aus).
   Tracking: dataLayer-Push, wenn vorhanden. */

(function () {
  'use strict';

  var STORAGE_PREFIX = 'jc.size_advisor.profile.';

  /* Ab dieser Koerpergroesse empfehlen wir die L-Ausfuehrung (laengerer
     Arm, laengerer Ruecken). 185 cm ist der dokumentierte JC-Kanon
     (Groessenhinweise des alten Themes: "Ab einer Koerpergroesse von
     185cm empfehlen wir Ihnen eine Langgroesse", von Niels 2026-07-27
     bestaetigt - gilt fuer Hemden UND Anzuege/Sakkos/Hosen). */
  var SHIRT_LANG_MIN_CM = 185;

  /* Laengen-Kategorien des Theme-Variant-Pickers (snippets/variant-picker.liquid).
     Der Picker blendet Groessen aus, die nicht zur gewaehlten Laenge passen.
     Wer eine Groesse vorbelegen will, muss vorher die Laenge umschalten. */
  function lengthCategory(sizeValue) {
    var n = parseInt(String(sizeValue), 10);
    if (isNaN(n)) return '';
    if (n >= 23 && n <= 31) return 'kurz';
    if (n >= 44 && n <= 64) return 'mittel';
    if (n >= 88) return 'lang';
    return '';
  }

  /* ---------- Config (lazy) ---------- */

  var configPromise = null;

  function loadConfig(url) {
    if (configPromise) return configPromise;
    if (!url) return Promise.reject(new Error('Size Advisor: Config-URL fehlt'));
    configPromise = fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('Size Advisor: Config HTTP ' + r.status);
      return r.json();
    });
    return configPromise;
  }

  /* ---------- Storage (Opt-in) ---------- */

  function storageKey(family) { return STORAGE_PREFIX + family; }

  function loadProfile(family) {
    try {
      var raw = window.localStorage.getItem(storageKey(family));
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function saveProfile(family, profile) {
    try {
      window.localStorage.setItem(storageKey(family), JSON.stringify(profile));
      return true;
    } catch (e) { return false; }
  }

  function clearProfile(family) {
    try {
      window.localStorage.removeItem(storageKey(family));
      return true;
    } catch (e) { return false; }
  }

  /* ---------- Tabellen-Zugriff ---------- */

  function allEntries(family) {
    var s = family.sizes || {};
    return [].concat(s.normal || [], s.lang || [], s.untersetzt || []);
  }

  function entryBySize(family, size) {
    var all = allEntries(family);
    for (var i = 0; i < all.length; i++) {
      if (String(all[i].size) === String(size)) return all[i];
    }
    return null;
  }

  /* Naechste Groesse zu einem Messwert. Liefert zusaetzlich, ob das Ergebnis
     mehrdeutig ist (zwei Groessen mit exakt gleichem Abstand). */
  function nearestByField(list, field, value) {
    var best = null, bestDiff = Infinity, tie = null;
    for (var i = 0; i < list.length; i++) {
      var v = list[i][field];
      if (v == null) continue;
      var diff = Math.abs(v - value);
      if (diff < bestDiff - 0.0001) {
        best = list[i]; bestDiff = diff; tie = null;
      } else if (Math.abs(diff - bestDiff) <= 0.0001 && best && list[i].size !== best.size) {
        tie = list[i];
      }
    }
    return { entry: best, diff: bestDiff, tie: tie };
  }

  /* Welche Groesse dieser Normal-Zeile passt zur Koerpergroesse? */
  function laengenGroesseFuer(family, entry, height) {
    var h = (family.rules && family.rules.body_height_cm) || {};
    if (h.untersetzt_max && height <= h.untersetzt_max && entry.alt_untersetzt) return entry.alt_untersetzt;
    if (h.lang_min && height >= h.lang_min && entry.alt_lang) return entry.alt_lang;
    return entry.size;
  }

  /* Normal-Zeile zu einer beliebigen Groesse (lang/untersetzt ueber equivalent_normal). */
  function normalEntryFuer(family, size) {
    var e = entryBySize(family, size);
    if (!e) return null;
    if (e.equivalent_normal) return entryBySize(family, e.equivalent_normal);
    return e;
  }

  /* Nachbargroesse (+1 / -1 in der Normal-Skala), in der zur Koerpergroesse
     passenden Laenge. */
  function nachbarGroesse(family, size, schritt, height) {
    var normal = family.sizes.normal || [];
    var ne = normalEntryFuer(family, size);
    if (!ne) return null;
    var idx = -1;
    for (var i = 0; i < normal.length; i++) if (normal[i].size === ne.size) { idx = i; break; }
    var ziel = normal[idx + schritt];
    if (!ziel) return null;
    return laengenGroesseFuer(family, ziel, height);
  }

  /* ---------- Plausibilitaet ---------- */

  /* Zwei Zonen je Massfeld (Niels 2026-08-20):
       - zwischen Tabellenrand und Plausibilitaetsgrenze: die Randgroesse
         benennen, keine stille Empfehlung ("unsere kleinste Groesse hat X cm")
       - jenseits der Plausibilitaetsgrenze: Rueckfrage zur Messweise, denn
         dort steht fast immer Koerperumfang statt Flachmass
     Koerpergroesse ausserhalb 150-210: keine Empfehlung.
     Grenzen kommen aus ui.plausibility der Config; die Defaults hier sind
     dieselben Werte, damit ein fehlender Config-Block nichts aendert. */
  var PLAUS = {
    body_height: { min: 150, max: 210 },
    chest_pit_to_pit: { min: 50, max: 78 },
    waistband: { min: 35, max: 65 },
    collar_cm: { min: 39, max: 48 }
  };
  function setPlausibility(p) {
    if (!p) return;
    for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k) && p[k] && typeof p[k] === 'object') PLAUS[k] = p[k];
  }

  function pruefeHoehe(height) {
    var b = PLAUS.body_height;
    if (height < b.min || height > b.max) return { ok: false, reason: 'height_out_of_range', value: height };
    return null;
  }

  /* null = Wert liegt im Tabellenbereich. Sonst der Fehler mit allem, was die
     Copy braucht (Randgroesse + ihr Tabellenwert bzw. der Rohwert). */
  function pruefeMass(list, field, value, plausKey, implausibleReason) {
    var vals = [];
    for (var i = 0; i < list.length; i++) if (list[i][field] != null) vals.push(list[i]);
    if (!vals.length) return null;
    vals.sort(function (a, b) { return a[field] - b[field]; });
    var lo = vals[0], hi = vals[vals.length - 1];
    var p = PLAUS[plausKey] || {};
    if ((p.min != null && value < p.min) || (p.max != null && value > p.max)) {
      return { ok: false, reason: implausibleReason, value: value };
    }
    if (value < lo[field]) return { ok: false, reason: 'below_table', value: value, size: lo.size, edge: lo[field] };
    if (value > hi[field]) return { ok: false, reason: 'above_table', value: value, size: hi.size, edge: hi[field] };
    return null;
  }

  /* ---------- Empfehlung ---------- */

  /* Sakko, Anzug UND Hose. Primaermass ist beim Sakko/Anzug die Brustweite,
     bei der Hose die Bundweite (Niels 2026-08-20: classic_hose bekommt eine
     eigene Fragenliste, die Brustweite war dort ein Konstruktionsfehler).

     v1.8 (Niels-Go 2026-09-08, nach Codex-Review): erst die Laengenlinie
     nach Koerpergroesse, dann die Weite IN dieser Linie, dann der Bund an
     der finalen Groesse. Vorher wurde die Normalgroesse gewaehlt und nur die
     Nummer getauscht - dabei wanderte die Weite mit (Hose 190 cm / Bund 48
     ergab 102 mit Tabellenbund 47 und verletzte die Hosenregel). */
  var ADVISOR_VERSION = 'v1.9';
  var EINE_GROESSE_CM = 2;

  function linieFuer(family, height) {
    var h = (family.rules && family.rules.body_height_cm) || {};
    if (h.untersetzt_max && height <= h.untersetzt_max) return 'untersetzt';
    if (h.lang_min && height >= h.lang_min) return 'lang';
    return 'normal';
  }

  /* Normalgroesse zu einer Zeile (lang/untersetzt ueber equivalent_normal). */
  function basisGroesse(entry) {
    return entry ? (entry.equivalent_normal || entry.size) : null;
  }

  /* Naechste Groesse in derselben Linie (Zeilen liegen aufsteigend). */
  function naechsteGroesseInLinie(family, entry, linie) {
    var rows = (family.sizes || {})[linie] || [];
    for (var i = 0; i < rows.length; i++) {
      if (String(rows[i].size) === String(entry.size)) return rows[i + 1] ? rows[i + 1].size : null;
    }
    return null;
  }

  /* Weite in einer Zeilenliste waehlen.
       Hose:  kleinste Zeile, deren Bund mindestens dem Mass entspricht (zu
              eng gibt es nicht, Niels 21.08.); liegt das Mass zwischen zwei
              Zeilen, werden beide genannt.
       Sakko: naechste Zeile; mehr als 0,5 cm von beiden entfernt = Grenzfall,
              Default die weitere (Niels 27.07./20.08.).
     Liefert null, wenn die Liste die Weite nicht abdeckt: Mass ueber der
     groessten Zeile, oder nur eine weitere Zeile und die mehr als eine
     Groesse (2 cm flach) entfernt. Dann faellt der Aufrufer auf Normal
     zurueck und sagt es dem Kunden (lengthFallback). */
  function waehleWeite(rows, field, mass, istHose) {
    var lower = null, upper = null;
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i][field];
      if (v == null) continue;
      if (v <= mass && (!lower || v > lower[field])) lower = rows[i];
      if (v >= mass && (!upper || v < upper[field])) upper = rows[i];
    }
    if (!upper) {
      /* Knapp ueber der groessten Zeile: beim Sakko noch "nah dran". */
      if (!istHose && lower && (mass - lower[field]) <= 0.5) {
        return { entry: lower, diff: mass - lower[field], grenzfall: null, edge: null };
      }
      return null;
    }
    if (!lower && (upper[field] - mass) > EINE_GROESSE_CM + 0.001) return null;
    if (istHose) {
      var gf = (lower && lower.size !== upper.size && mass > lower[field]) ? { lowerEntry: lower, upperEntry: upper } : null;
      return { entry: upper, diff: upper[field] - mass, grenzfall: gf, edge: null };
    }
    if (lower && upper && lower.size !== upper.size && (mass - lower[field]) > 0.5 && (upper[field] - mass) > 0.5) {
      return { entry: upper, diff: upper[field] - mass, grenzfall: { lowerEntry: lower, upperEntry: upper }, edge: null };
    }
    var hit = nearestByField(rows, field, mass);
    var edge = (!lower && hit.entry === upper && hit.diff > 0.5) ? 'wider' : null;
    return { entry: hit.entry, diff: hit.diff, grenzfall: null, edge: edge };
  }

  /* Anzug: Hosenbund an der finalen Groesse (Niels 08.09., Ladenszenen).
     d = Kundenmass - Tabellenbund, cm flach. Zonen aus family.waist_zones:
       |d| <= fit (1)            passt, beide Zahlen nennen
       fit < d <= tight (2)      etwas enger, sonst die naechste Groesse
       tight < d <= upsize (4)   Empfehlung wird die naechste Groesse derselben
                                 Linie (wer beim Bund so weit ueber der Tabelle
                                 liegt, hat meist auch das Sakko knapp gewaehlt)
       d > upsize                Messung pruefen
       -upsize <= d < -fit       weiter: nur die Tatsache, kein Hilfsmittel
       d < -upsize               Messung pruefen
     Bund ausserhalb der Plausibilitaet: Rueckfrage als Hinweis, das Sakko
     bleibt. Klassifiziert wird der rohe Wert, gerundet nur die Anzeige. */
  function pruefeBund(family, entry, userWaist, linie) {
    if (!entry || entry.waistband == null || userWaist == null || isNaN(userWaist)) return null;
    var p = PLAUS.waistband || {};
    if ((p.min != null && userWaist < p.min) || (p.max != null && userWaist > p.max)) {
      return { status: 'implausible', delta: null, waistband: entry.waistband, user: userWaist, up: null };
    }
    var z = family.waist_zones || {};
    var fit = z.fit != null ? z.fit : 1;
    var tight = z.tight != null ? z.tight : 2;
    var up = z.upsize != null ? z.upsize : 4;
    var d = userWaist - entry.waistband;
    var naechste = naechsteGroesseInLinie(family, entry, linie);
    var status;
    if (d > up || d < -up) status = 'check';
    else if (d > tight) status = naechste ? 'upsize' : 'beyond';
    else if (d > fit) status = naechste ? 'tight' : 'beyond';
    else if (d < -fit) status = 'wide';
    else status = 'fit';
    return { status: status, delta: Math.round(Math.abs(d) * 2) / 2, waistband: entry.waistband, user: userWaist, up: naechste };
  }

  function recommendSuit(family, input) {
    var normal = family.sizes.normal;
    var rules = family.rules || {};
    var height = parseInt(input.body_height, 10);
    var istHose = family.input_mode === 'trousers';
    var cf = istHose ? (rules.waist_field || 'waist') : (rules.chest_field || 'chest');
    var roh = istHose ? input.waistband : input.chest_pit_to_pit;
    var mass = roh ? parseFloat(roh) : null;
    var hatMass = mass != null && !isNaN(mass);
    var konfektion = input.konfektion || null;

    if (!height || isNaN(height)) return { ok: false, reason: 'missing_height' };
    var hErr = pruefeHoehe(height);
    if (hErr) return hErr;
    if (!hatMass && !konfektion) return { ok: false, reason: 'missing_input' };

    var linie = linieFuer(family, height);
    /* Ab 185 cm ist Lang nur eine Moeglichkeit. Ohne ausdrueckliche
       bisherige Langgroessenwahl keine automatische Laengenempfehlung. */
    if (linie === 'lang') {
      if (input.long_size_history === 'no') linie = 'normal';
      else if (input.long_size_history !== 'yes') {
        return { ok: false, reason: input.long_size_history === 'unsure'
          ? 'length_uncertain' : 'missing_length_history' };
      }
    }
    var entry = null, source, diff = null, grenzfall = null, edge = null, fallback = null;

    if (hatMass) {
      /* Plausibilitaet und Tabellenrand gegen die Normal-Tabelle: sie deckt
         den ganzen Weitenbereich ab, die Laengenlinien nur Ausschnitte. */
      var mErr = pruefeMass(normal, cf, mass,
        istHose ? 'waistband' : 'chest_pit_to_pit',
        istHose ? 'implausible_waist' : 'implausible_chest');
      if (mErr) return mErr;
      source = istHose ? 'waist' : 'chest';
      var wahl = linie !== 'normal' ? waehleWeite((family.sizes || {})[linie] || [], cf, mass, istHose) : null;
      if (!wahl) {
        if (linie !== 'normal') { fallback = linie + '_missing'; linie = 'normal'; }
        wahl = waehleWeite(normal, cf, mass, istHose);
      }
      if (!wahl) return { ok: false, reason: 'invalid_input' };
      entry = wahl.entry; diff = wahl.diff; edge = wahl.edge;
      if (wahl.grenzfall) grenzfall = { down: wahl.grenzfall.lowerEntry.size, up: wahl.grenzfall.upperEntry.size };
    } else {
      /* Nur Konfektion: die Zuordnung zur Laenge bleibt die Orientierung,
         es gibt keinen gemessenen Weitenabgleich. */
      var base = entryBySize(family, konfektion);
      if (!base) return { ok: false, reason: 'invalid_input' };
      source = 'konfektion';
      if (linie === 'untersetzt') {
        if (base.alt_untersetzt) entry = entryBySize(family, base.alt_untersetzt);
        else { entry = base; fallback = 'untersetzt_missing'; linie = 'normal'; }
      } else if (linie === 'lang') {
        if (base.alt_lang) entry = entryBySize(family, base.alt_lang);
        else { entry = base; fallback = 'lang_missing'; linie = 'normal'; }
      } else entry = base;
    }
    if (!entry) return { ok: false, reason: 'invalid_input' };

    var size = entry.size;
    var upsizedFrom = null;
    var waistCheck = null;
    if (family.anzug_trouser_check && input.waistband) {
      waistCheck = pruefeBund(family, entry, parseFloat(input.waistband), linie);
      if (waistCheck && waistCheck.status === 'upsize') {
        upsizedFrom = size;
        size = waistCheck.up;
        entry = entryBySize(family, size);
        grenzfall = null; edge = null; diff = null;
      }
    }

    return {
      ok: true, mode: istHose ? 'trousers' : 'suit', size: size, baseSize: basisGroesse(entry),
      lengthVariant: linie, lengthFallback: fallback, source: source, chestDiff: diff,
      bodyHeight: height, measure: hatMass ? mass : null, longSizeHistory: input.long_size_history || null,
      waistCheck: waistCheck, grenzfall: grenzfall, edge: edge, upsizedFrom: upsizedFrom
    };
  }

  function recommendShirt(family, input) {
    var normal = family.sizes.normal;
    var rules = family.rules || {};
    var height = parseInt(input.body_height, 10);
    var collarSize = input.collar_size || null;
    var collarCm = input.collar_cm ? parseFloat(input.collar_cm) : null;
    var chest = input.chest_pit_to_pit ? parseFloat(input.chest_pit_to_pit) : null;

    if (!height || isNaN(height)) return { ok: false, reason: 'missing_height' };
    var hErr = pruefeHoehe(height);
    if (hErr) return hErr;

    var base = null, source = null, diff = null, tie = null;

    /* Reihenfolge nach Eindeutigkeit (Niels 2026-08-20): das gemessene
       Kragenmass schlaegt die genannte Kragengroesse. Die Groesse ist ein
       Label und je nach Marke eine halbe Stufe anders, das Zentimetermass
       nicht. Die Brustweite kommt zuletzt. */
    if (collarCm != null && !isNaN(collarCm)) {
      var cErr = pruefeMass(normal, rules.collar_field || 'collar', collarCm, 'collar_cm', 'implausible_collar');
      if (cErr) return cErr;
      var hitC = nearestByField(normal, rules.collar_field || 'collar', collarCm);
      base = hitC.entry; diff = hitC.diff; source = 'collar_cm';
    } else if (collarSize) {
      base = entryBySize(family, collarSize);
      source = 'collar_size';
    } else if (chest != null && !isNaN(chest)) {
      var bErr = pruefeMass(normal, rules.chest_field || 'chest', chest, 'chest_pit_to_pit', 'implausible_chest');
      if (bErr) return bErr;
      var hitB = nearestByField(normal, rules.chest_field || 'chest', chest);
      base = hitB.entry; diff = hitB.diff; tie = hitB.tie; source = 'chest';
    } else {
      return { ok: false, reason: 'missing_input' };
    }

    if (!base) return { ok: false, reason: 'invalid_input' };

    /* Gleicher Abstand zu zwei Groessen (bei ganzzahligen Eingaben haeufig):
       nicht raten, sondern nach der Kragenweite fragen. */
    if (tie) {
      return { ok: false, reason: 'ambiguous_chest', sizeA: base.size, sizeB: tie.size };
    }

    var variant = 'normal', size = base.size;
    if (height >= SHIRT_LANG_MIN_CM && base.alt_lang) {
      variant = 'lang'; size = base.alt_lang;
    }

    return {
      ok: true, mode: 'shirt', size: size, baseSize: base.size,
      lengthVariant: variant, source: source, measureDiff: diff, bodyHeight: height
    };
  }

  function recommend(family, input) {
    /* suit, trousers und alles Unbekannte laufen ueber recommendSuit */
    return family.input_mode === 'shirt'
      ? recommendShirt(family, input)
      : recommendSuit(family, input);
  }

  /* ---------- Verfuegbarkeit + Alternative ---------- */

  function isAvailable(variants, size) {
    var v = variants[size];
    return !!(v && v.available);
  }

  /* Welche Laengen-Skala fuehrt diese Groesse? */
  function scaleOf(family, size) {
    var sk = ['normal', 'lang', 'untersetzt'];
    for (var k = 0; k < sk.length; k++) {
      var list = (family.sizes || {})[sk[k]] || [];
      for (var i = 0; i < list.length; i++) if (String(list[i].size) === String(size)) return sk[k];
    }
    return null;
  }

  /* Baender um die Laengen-Schwellen, innerhalb derer eine andere Laenge als
     Alternative angeboten werden darf (Niels 2026-08-20/21). Massgeblich ist,
     was der Aenderungsschneider am Sakko noch retten kann:
       Aermel kuerzen leicht, Aermel auslassen nur 2-3 cm und aufwendig,
       Ruecken kuerzen 1-3 cm (Buttoning Point), Ruecken verlaengern gar nicht.
       lang -> normal:        nur bis lang_min + 1        (185/186)  3 cm zu kurz, bleibt so
       untersetzt -> normal:  ab  untersetzt_max - 3      (169)      2 cm zu lang, kuerzbar
       normal -> lang:        ab  lang_min - 4            (181)      3 cm zu lang, an der Grenze  [Default]
       normal -> untersetzt:  bis untersetzt_max + 3      (175)      Sakkos fallen lang aus, bewusste Ueberlappung
     Werte aus ui.alternative_height_bands der Config. */
  var ALT_BANDS = {
    lang_to_normal_max_above_lang_min: 1,
    untersetzt_to_normal_max_below_untersetzt_max: 3,
    normal_to_lang_max_below_lang_min: 4,
    normal_to_untersetzt_max_above_untersetzt_max: 3
  };
  function setAltBands(b) {
    if (!b) return;
    for (var k in b) if (Object.prototype.hasOwnProperty.call(b, k) && typeof b[k] === 'number') ALT_BANDS[k] = b[k];
  }

  function laengenwechselErlaubt(family, von, nach, height) {
    if (height == null || isNaN(height)) return false;
    var h = (family.rules && family.rules.body_height_cm) || {};
    var langMin = h.lang_min || SHIRT_LANG_MIN_CM;
    var kurzMax = h.untersetzt_max || 172;
    if (von === 'lang' && nach === 'normal') return height <= langMin + ALT_BANDS.lang_to_normal_max_above_lang_min;
    if (von === 'untersetzt' && nach === 'normal') return height >= kurzMax - ALT_BANDS.untersetzt_to_normal_max_below_untersetzt_max;
    if (von === 'normal' && nach === 'lang') return height >= langMin - ALT_BANDS.normal_to_lang_max_below_lang_min;
    if (von === 'normal' && nach === 'untersetzt') return height <= kurzMax + ALT_BANDS.normal_to_untersetzt_max_above_untersetzt_max;
    return false;
  }

  /* Alternativen bei Ausverkauft (v1.8, Niels 08.09.). Jede Alternative wird
     in ihrer Linie mit derselben Weitenregel gewaehlt und bekommt ihre
     eigenen Differenzen (Ruecken/Arm bzw. Bein) und beim Anzug ihren
     eigenen Bund-Befund.
       Sakko/Anzug: nur eine andere Laenge innerhalb der Hoehen-Baender,
                    nie die Nachbarweite (das Sakko setzt die Groesse).
       Hose:        erst die andere Laenge (Band zuerst, dann die uebrigen
                    mit Aenderung), dann eine Groesse weiter in derselben
                    Linie. Hoechstens zwei. Keine engere Hose (zu eng gibt
                    es nicht), kein Guertel-Satz. */
  function findAlternatives(family, rec, variants) {
    var entry = entryBySize(family, rec.size);
    if (!entry) return [];
    var istHose = family.input_mode === 'trousers';
    var rules = family.rules || {};
    var cf = istHose ? (rules.waist_field || 'waist') : (rules.chest_field || 'chest');
    var von = rec.lengthVariant || scaleOf(family, rec.size);
    var mass = (rec.measure != null && rec.source !== 'konfektion') ? rec.measure : null;
    var userWaist = (rec.waistCheck && rec.waistCheck.user != null) ? rec.waistCheck.user : null;
    var d = function (a, b, f) {
      return (a && b && a[f] != null && b[f] != null) ? Math.round((b[f] - a[f]) * 10) / 10 : null;
    };
    var bau = function (ae, kind, linie) {
      return { size: ae.size, kind: kind, line: linie, base: basisGroesse(ae),
               sleeveDelta: d(entry, ae, 'sleeve'), backDelta: d(entry, ae, 'back_length'),
               inseamDelta: d(entry, ae, 'inseam'),
               waistDelta: d(entry, ae, istHose ? 'waist' : 'waistband'),
               waistDeltaUser: (istHose && mass != null && ae[cf] != null) ? Math.round((ae[cf] - mass) * 10) / 10 : null,
               waistCheck: (family.anzug_trouser_check && userWaist != null) ? pruefeBund(family, ae, userWaist, linie) : null };
    };
    /* Kandidat in einer anderen Linie: die Weite dort neu waehlen. */
    var inLinie = function (linie) {
      var rows = (family.sizes || {})[linie] || [];
      if (!rows.length) return null;
      var ae = null;
      if (mass != null) {
        var w = waehleWeite(rows, cf, mass, istHose);
        ae = w ? w.entry : null;
      } else {
        var ne = normalEntryFuer(family, rec.size);
        if (!ne) return null;
        if (linie === 'normal') ae = ne;
        else if (linie === 'lang' && ne.alt_lang) ae = entryBySize(family, ne.alt_lang);
        else if (linie === 'untersetzt' && ne.alt_untersetzt) ae = entryBySize(family, ne.alt_untersetzt);
      }
      return (ae && String(ae.size) !== String(rec.size) && isAvailable(variants, ae.size)) ? ae : null;
    };
    var linien = ['normal', 'lang', 'untersetzt'].filter(function (l) {
      return l !== von && !(l === 'lang' && family.input_mode !== 'shirt' && rec.longSizeHistory !== 'yes');
    });
    var out = [];
    var schonDrin = function (size) { return out.some(function (o) { return String(o.size) === String(size); }); };

    /* 1. andere Laenge innerhalb der Baender (ohne Aenderung) */
    linien.forEach(function (l) {
      if (out.length || !laengenwechselErlaubt(family, von, l, rec.bodyHeight)) return;
      var ae = inLinie(l);
      if (ae && !schonDrin(ae.size)) out.push(bau(ae, 'length', l));
    });
    if (!istHose) return out.slice(0, 1);

    /* 2. Hose: andere Laenge ausserhalb der Baender, nur mit laengerem Bein
       (kuerzen ist eine Kleinigkeit; ein kuerzeres Bein ausserhalb des
       Bandes waere eine Kurzgroesse fuer einen 183-cm-Mann). Hoechstens
       EINE Laengen-Alternative, damit die weitere Groesse Platz behaelt. */
    linien.forEach(function (l) {
      if (out.length || laengenwechselErlaubt(family, von, l, rec.bodyHeight)) return;
      var ae = inLinie(l);
      if (!ae || schonDrin(ae.size)) return;
      var kand = bau(ae, 'length_alter', l);
      if (kand.inseamDelta != null && kand.inseamDelta > 0) out.push(kand);
    });
    /* 3. Hose: eine Groesse weiter in derselben Linie */
    var hoch = naechsteGroesseInLinie(family, entry, von);
    if (hoch && isAvailable(variants, hoch) && !schonDrin(hoch)) out.push(bau(entryBySize(family, hoch), 'size_up', von));
    return out.slice(0, 2);
  }

  /* Kompatibler Einzelaufruf (Tests, Hemden): erste Alternative oder null.
     Ohne Messwert laeuft die Wahl ueber die Aequivalenz-Zuordnung. */
  function findAlternative(family, size, variants, bodyHeight, longSizeHistory) {
    var rec = { size: size, lengthVariant: scaleOf(family, size), bodyHeight: bodyHeight,
                source: 'konfektion', measure: null, waistCheck: null, longSizeHistory: longSizeHistory || null };
    if (bodyHeight == null || isNaN(bodyHeight)) return null;
    var alts = findAlternatives(family, rec, variants);
    return alts.length ? alts[0] : null;
  }

  /* ---------- Variant-Picker vorbelegen ---------- */

  /* Den richtigen Picker finden. Die Klasse .variant-picker vergibt das Theme
     ZWEIMAL: einmal an den echten Optionen-Picker und einmal an den Block
     'product_variations' (Querverlinkung verwandter Produkte), der gar keine
     Options-Inputs enthaelt. Der steht im DOM weiter oben. Wer einfach den
     ersten nimmt, greift ins Leere. Massgeblich ist deshalb nicht die Klasse,
     sondern ob Options-Inputs drinstecken. */
  function findePicker(root) {
    var scope = root.closest('.shopify-section, section, product-info') || document;
    var kandidaten = Array.prototype.slice.call(scope.querySelectorAll('.variant-picker'));
    if (!kandidaten.length) {
      kandidaten = Array.prototype.slice.call(document.querySelectorAll('.variant-picker'));
    }
    for (var i = 0; i < kandidaten.length; i++) {
      if (kandidaten[i].querySelector('input[type="radio"][name^="options["], select[name^="options["]')) {
        return kandidaten[i];
      }
    }
    return scope === document ? document.body : scope;
  }

  function istVersteckt(el) {
    return !(el.offsetParent || el.getClientRects().length);
  }

  /* Gibt { ok, reason } zurueck. reason ist fuer Tracking und Fehlermeldung da,
     denn ein stilles Nichtstun ist bei diesem Button die schlechteste Variante. */
  function preSelectVariant(root, sizeValue) {
    var picker = findePicker(root);
    var ziel = String(sizeValue).trim();

    /* Schritt 1: Laengen-Filter umschalten, sonst ist die Ziel-Groesse
       display:none und der Picker springt gleich wieder zurueck.
       Betrifft Sakkos und Hosen, bei Hemden existiert der Filter nicht. */
    var cat = lengthCategory(ziel);
    if (cat) {
      var lenRadio = picker.querySelector('input[name="__virtual_length"][value="' + cat + '"]');
      if (lenRadio && !lenRadio.checked) {
        setzeRadio(lenRadio, picker);
      }
    }

    /* Schritt 2: Groessen-Radio setzen. */
    var radios = picker.querySelectorAll('input[type="radio"][name^="options["]');
    for (var i = 0; i < radios.length; i++) {
      if (String(radios[i].value).trim() !== ziel) continue;
      var radio = radios[i];
      if (radio.checked) return { ok: true, reason: 'bereits_gewaehlt' };

      /* Das Theme deaktiviert Groessen, die es in der gerade gewaehlten Farbe
         nicht gibt, und blendet sie aus. Dann laesst sich nichts setzen, und
         der Kunde muss das erfahren statt einen toten Button zu druecken. */
      var wrapper = radio.closest('.variant-input__item') || radio.parentElement;
      if (radio.disabled || (wrapper && istVersteckt(wrapper))) {
        return { ok: false, reason: 'in_dieser_farbe_nicht_waehlbar' };
      }

      setzeRadio(radio, picker);
      return radio.checked ? { ok: true, reason: 'gesetzt' } : { ok: false, reason: 'nicht_uebernommen' };
    }

    /* Fallback: aeltere Themes mit <select> statt Radios. */
    var selects = picker.querySelectorAll('select[name^="options["]');
    for (var s = 0; s < selects.length; s++) {
      var opts = selects[s].options;
      for (var o = 0; o < opts.length; o++) {
        if (opts[o].value.trim() === ziel) {
          selects[s].value = opts[o].value;
          selects[s].dispatchEvent(new Event('change', { bubbles: true }));
          return { ok: true, reason: 'select_gesetzt' };
        }
      }
    }
    return { ok: false, reason: 'groesse_nicht_im_picker' };
  }

  /* Erst der echte Label-Klick: der laeuft durch dieselben Handler wie eine
     Kundeninteraktion. Nur wenn das nichts bewirkt, direkt setzen und die
     Events selbst feuern. */
  function setzeRadio(radio, picker) {
    var escId = (window.CSS && CSS.escape) ? CSS.escape(radio.id) : radio.id;
    var label = radio.id ? picker.querySelector('label[for="' + escId + '"]') : null;
    if (label) {
      label.click();
      if (radio.checked) return;
    }
    radio.checked = true;
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- Bestell-Marker ---------- */

  /* Niels 2026-08-20: Retourenquote mit und ohne Berater trennen. Versteckte
     Line-Item-Property im Produktformular. Unterstrich-Praefix = im Checkout
     und in den Mails unsichtbar, im Bestell-Export als Zeilen-Eigenschaft
     lesbar. Wird nur gesetzt, wenn das Uebernehmen wirklich geklappt hat. */
  function markiereWarenkorb(root, family, empfohlen, uebernommen, waist) {
    /* Prestige rendert MEHRERE cart/add-Formulare (Hauptformular, Raten-
       Widget, Sticky-Leiste). Welches abgeschickt wird, haengt vom Klick ab,
       deshalb der Marker in ALLE (Browser-Smoke 2026-08-21: das erste im
       DOM war das Raten-Formular, der Marker waere nie mitgegangen). */
    var scope = root.closest('.shopify-section, section, product-info') || document;
    var forms = Array.prototype.slice.call(scope.querySelectorAll('form[action*="/cart/add"]'));
    if (!forms.length) forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    if (!forms.length) return false;
    /* Die gekaufte Groesse ist die Variante der Bestellposition. "applied"
       dokumentiert nur den Klick, nie eine spaetere manuelle Auswahl. */
    var wert = family + '|rec:' + empfohlen + '|state:' + (uebernommen ? 'applied' : 'shown')
      + (uebernommen ? '|applied:' + uebernommen : '') + (waist ? '|waist:' + waist : '');
    forms.forEach(function (form) {
      var inp = form.querySelector('input[name="properties[_size_advisor]"]');
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[_size_advisor]';
        form.appendChild(inp);
      }
      inp.value = wert;
    });
    return true;
  }

  /* Warenkorbmerkmal ueberlebt Seitenwechsel und manuelle Auswahl. Der
     Bestell-Workflow wandelt es in den sichtbaren Tag um. Keine Koerpermasse. */
  var nutzungsMarkierung = null;
  var nutzungGemerkt = false;
  function markiereNutzung() {
    nutzungGemerkt = true;
    if (nutzungsMarkierung) return nutzungsMarkierung;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    nutzungsMarkierung = fetch(base + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { size_advisor_used: 'yes' } })
    }).then(function (r) {
      if (!r.ok) throw new Error('Size Advisor: Warenkorbmarkierung fehlgeschlagen');
      return r.json();
    }).catch(function (e) {
      nutzungsMarkierung = null;
      console.warn(e.message);
    });
    return nutzungsMarkierung;
  }

  /* Ein leerer Warenkorb kann beim ersten Hinzufuegen neu aufgebaut werden.
     Nach dem Theme-Ereignis den Marker gegebenenfalls erneut setzen. */
  function pruefeWarenkorbMarkierung(cart) {
    if (!cart) return;
    var hatAttribut = cart.attributes && cart.attributes.size_advisor_used === 'yes';
    var hatPosition = (cart.items || []).some(function (item) {
      return item.properties && !!item.properties._size_advisor;
    });
    if (hatAttribut || hatPosition) nutzungGemerkt = true;
    if (nutzungGemerkt && !hatAttribut) {
      nutzungsMarkierung = null;
      markiereNutzung();
    }
  }

  /* ---------- Tracking ---------- */

  function trackEvent(name, payload) {
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      var data = { event: 'size_advisor_' + name };
      for (var k in payload) { if (Object.prototype.hasOwnProperty.call(payload, k)) data[k] = payload[k]; }
      window.dataLayer.push(data);
    }
  }

  /* ---------- Formular bauen ---------- */

  function fill(tpl, values) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, key) {
      return values[key] != null ? values[key] : m;
    });
  }

  /* ---------- UK/US-Anzeige (nur EN-Locale, v1.6) ---------- */

  /* Der Variant-Picker zeigt auf EN UK/US-Groessen (Umschalter 01.09.2026).
     Der Berater nennt Groessen auf EN deshalb dual: "36R (EU 46)". Nur
     Anzeige - gerechnet/uebernommen wird die DE-Groesse. Quellen: Sakko/Anzug
     Formel (n-10 mit R/L/S ueber die Laengen-Aequivalenz), Hose
     entry.jeans_size (nur Waist), Hemd entry.english_size. Unbekannter Wert
     oder fehlende Config (Trigger-Label vor dem Lazy-Load): "EU <n>". */
  function displaySize(familyKey, family, locale, size) {
    if (String(locale).toLowerCase() !== 'en' || size == null || size === '') return String(size);
    var s = String(size), conv = null;
    if (familyKey === 'classic_sakko' || familyKey === 'classic_anzug') {
      if (/^\d+$/.test(s)) {
        var n = parseInt(s, 10);
        if (n >= 44 && n <= 64) conv = (n - 10) + 'R';
        else if (n >= 88 && n % 2 === 0) conv = ((n + 2) / 2 - 10) + 'L';
        else if (n >= 23 && n <= 31) conv = (2 * n - 10) + 'S';
      }
    } else if (family) {
      var entry = entryBySize(family, s);
      if (entry && entry.jeans_size) conv = 'W' + String(entry.jeans_size).split('/')[0];
      else if (entry && entry.english_size) conv = String(entry.english_size);
    }
    return conv ? conv + ' (EU ' + s + ')' : 'EU ' + s;
  }

  /* ---------- Einheiten cm/in (nur EN-Locale, v1.7) ---------- */

  var CM_PER_IN = 2.54;
  var UNITS_KEY = 'jc.size_advisor.units';

  function inToCm(v) {
    var n = parseFloat(v);
    return isNaN(n) ? null : Math.round(n * CM_PER_IN * 100) / 100;
  }
  function cmToIn(v, dez) {
    var n = parseFloat(v);
    if (isNaN(n)) return null;
    var f = Math.pow(10, dez == null ? 1 : dez);
    return Math.round(n / CM_PER_IN * f) / f;
  }
  function ftInToCm(ft, inch) {
    var f = parseFloat(ft), i = parseFloat(inch);
    if (isNaN(f)) return null;
    if (isNaN(i)) i = 0;
    return Math.round((f * 12 + i) * CM_PER_IN);
  }
  function cmToFtIn(cm) {
    var n = parseFloat(cm);
    if (isNaN(n)) return null;
    var ges = Math.round(n / CM_PER_IN);
    return { ft: Math.floor(ges / 12), inch: ges % 12 };
  }
  function fmtHeight(cm) {
    var fi = cmToFtIn(cm);
    return fi ? fi.ft + "'" + fi.inch + '"' : String(cm);
  }

  /* Einheiten-Modus einer Instanz: Kunden-Override (eigener Storage-Key) ->
     Picker-Toggle (jc_size_system) -> Picker-Default. Nur EN, sonst hart cm. */
  function unitModeFuer(root) {
    if ((root.dataset.locale || '') !== 'en') return 'cm';
    try {
      var eigen = localStorage.getItem(UNITS_KEY);
      if (eigen === 'cm' || eigen === 'in') return eigen;
    } catch (e) {}
    try {
      var sys = localStorage.getItem('jc_size_system');
      if (sys === 'ukus') return 'in';
      if (sys === 'eu') return 'cm';
    } catch (e) {}
    var liste = document.querySelector('[data-size-list]');
    return (liste && liste.getAttribute('data-size-default')) === 'ukus' ? 'in' : 'cm';
  }

  /* Copy-Aufloesung: im Inch-Modus zuerst der _in-Key, sonst die Basis.
     keys darf ein Array sein (Fallback-Kette, z.B. trousers -> suit). */
  function copyFuer(copy, root, keys) {
    var inch = root.dataset.unitMode === 'in';
    var liste = Array.isArray(keys) ? keys : [keys];
    for (var i = 0; i < liste.length; i++) {
      if (!liste[i]) continue;
      if (inch && copy[liste[i] + '_in']) return copy[liste[i] + '_in'];
      if (copy[liste[i]]) return copy[liste[i]];
    }
    return null;
  }

  function buildFields(root, family, ui, copy, uid, onUnitChange) {
    var host = root.querySelector('[data-size-advisor-fields]');
    if (!host) return;
    host.innerHTML = '';
    var inch = root.dataset.unitMode === 'in';

    /* cm/in-Umschalter (nur EN). Lebt IM Fields-Container und wird beim
       Rebuild mit erzeugt; der Zustand haengt an root.dataset.unitMode. */
    if ((root.dataset.locale || '') === 'en' && typeof onUnitChange === 'function') {
      var uwrap = document.createElement('div');
      uwrap.className = 'size-advisor__units';
      uwrap.setAttribute('role', 'group');
      uwrap.setAttribute('aria-label', copy.units_label || 'Units');
      ['cm', 'in'].forEach(function (u) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-unit', u);
        b.setAttribute('aria-pressed', String((inch ? 'in' : 'cm') === u));
        b.textContent = u === 'cm' ? (copy.units_cm || 'cm') : (copy.units_inch || 'in');
        b.addEventListener('click', function () { onUnitChange(u); });
        uwrap.appendChild(b);
      });
      host.appendChild(uwrap);
    }

    var mode = family.input_mode || 'suit';
    var setKey = mode === 'shirt' ? 'shirt' : (mode === 'trousers' ? 'trousers' : 'suit');
    var ids = (ui.question_sets && ui.question_sets[setKey]) || [];
    /* Anzug (2026-07-27): Sakko-Fragen plus Bundweite der Hose.
       Copy-Keys bleiben im suit-Namensraum (q_suit_waistband_*). */
    if (family.anzug_trouser_check) ids = ids.concat(['waistband']);
    if (mode !== 'shirt') ids = ids.concat(['long_size_history']);

    ids.forEach(function (qid) {
      var spec = (ui.questions && ui.questions[qid]) || {};
      /* Hosen-Fragen greifen auf die Sakko-Texte zurueck, wo kein eigener
         steht (Koerpergroesse, Bundweiten-Label). */
      var labelTxt = copyFuer(copy, root, ['q_' + setKey + '_' + qid + '_label',
        setKey === 'trousers' ? 'q_suit_' + qid + '_label' : null]) || qid;
      var helpTxt = copyFuer(copy, root, ['q_' + setKey + '_' + qid + '_help',
        setKey === 'trousers' ? 'q_suit_' + qid + '_help' : null]) || '';
      var inputId = 'sa-' + qid + '-' + uid;

      var wrap = document.createElement('div');
      wrap.className = 'size-advisor__field';
      wrap.setAttribute('data-field', qid);

      var label = document.createElement('label');
      label.className = 'size-advisor__label';
      label.setAttribute('for', inputId);
      label.textContent = labelTxt;
      if (spec.required) {
        var star = document.createElement('span');
        star.className = 'size-advisor__required';
        star.setAttribute('aria-hidden', 'true');
        star.textContent = ' *';
        label.appendChild(star);
      }
      wrap.appendChild(label);

      if (helpTxt) {
        var help = document.createElement('p');
        help.className = 'size-advisor__help';
        help.id = inputId + '-help';
        help.textContent = helpTxt;
        wrap.appendChild(help);
      }

      var input;
      if (spec.type === 'select') {
        input = document.createElement('select');
        input.className = 'size-advisor__select';
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = (qid === 'long_size_history' ? copy.long_history_placeholder : copy.select_placeholder) || '';
        input.appendChild(ph);
        (spec.options || family.sizes.normal || []).forEach(function (e) {
          var opt = document.createElement('option');
          opt.value = e.size; /* value bleibt DE - nur die Anzeige konvertiert */
          opt.textContent = e.copy_key ? copy[e.copy_key] : displaySize(root.dataset.family, family, root.dataset.locale, e.size);
          input.appendChild(opt);
        });
      } else if (inch && qid === 'body_height') {
        /* Inch-Modus: Koerpergroesse als ft+in-Doppelfeld (5'10" statt 178).
           Namen body_height_ft/_in; leseWerteCm rechnet daraus cm. */
        var paar = document.createElement('div');
        paar.className = 'size-advisor__height-pair';
        [['body_height_ft', 'q_height_ft_label', 4, 7, spec.required],
         ['body_height_in', 'q_height_in_label', 0, 11, false]].forEach(function (def) {
          var teil = document.createElement('span');
          teil.className = 'size-advisor__height-part';
          var inp = document.createElement('input');
          inp.className = 'size-advisor__input';
          inp.type = 'number';
          inp.inputMode = 'numeric';
          inp.min = def[2];
          inp.max = def[3];
          inp.step = 1;
          inp.name = def[0];
          inp.id = 'sa-' + def[0] + '-' + uid;
          if (def[4]) inp.required = true;
          if (helpTxt) inp.setAttribute('aria-describedby', inputId + '-help');
          var sub = document.createElement('label');
          sub.className = 'size-advisor__unit-sub';
          sub.setAttribute('for', inp.id);
          sub.textContent = copy[def[1]] || def[1];
          teil.appendChild(inp);
          teil.appendChild(sub);
          paar.appendChild(teil);
        });
        label.setAttribute('for', 'sa-body_height_ft-' + uid);
        wrap.appendChild(paar);
        host.appendChild(wrap);
        return;
      } else {
        input = document.createElement('input');
        input.className = 'size-advisor__input';
        input.type = 'number';
        if (inch) {
          /* Grenzen aus der cm-Spec konvertiert; Viertel-Inch-Schritte. */
          input.inputMode = 'decimal';
          if (spec.min != null) input.min = cmToIn(spec.min, 1);
          if (spec.max != null) input.max = cmToIn(spec.max, 1);
          input.step = 0.25;
        } else {
          input.inputMode = spec.step && spec.step < 1 ? 'decimal' : 'numeric';
          if (spec.min != null) input.min = spec.min;
          if (spec.max != null) input.max = spec.max;
          if (spec.step != null) input.step = spec.step;
        }
      }
      input.id = inputId;
      input.name = qid;
      if (spec.required) input.required = true;
      if (helpTxt) input.setAttribute('aria-describedby', inputId + '-help');
      wrap.appendChild(input);

      host.appendChild(wrap);
    });
    host.oninput = host.onchange = function () { zeigeLaengenfrage(root, family); };
    zeigeLaengenfrage(root, family);
  }

  function zeigeLaengenfrage(root, family) {
    var field = root.querySelector('[data-field="long_size_history"]');
    if (!field) return;
    var form = root.querySelector('[data-size-advisor-form]');
    var input = leseWerteCm(form, root.dataset.unitMode === 'in');
    var sichtbar = Number(input.body_height) >= ((family.rules.body_height_cm || {}).lang_min || 185);
    field.hidden = !sichtbar;
    field.querySelector('select').required = sichtbar;
  }

  /* Formularwerte einsammeln und nach cm normalisieren (v1.7). Die Logik
     rechnet ausschliesslich cm; Inch existiert nur in den Feldern. */
  function leseWerteCm(form, inch) {
    function num(name) {
      var el = form[name];
      if (!el || el.value === '' || el.value == null) return null;
      if (!inch) return el.value;
      var cm = inToCm(el.value);
      return cm == null ? null : String(cm);
    }
    function roh(name) {
      var el = form[name];
      return el && el.value !== '' ? el.value : null;
    }
    var hoehe = null;
    if (inch) {
      var ft = form['body_height_ft'];
      if (ft && ft.value !== '') {
        var zoll = form['body_height_in'];
        var cm = ftInToCm(ft.value, zoll ? zoll.value : 0);
        if (cm != null) hoehe = String(cm);
      }
    } else if (form['body_height'] && form['body_height'].value !== '') {
      hoehe = form['body_height'].value;
    }
    return {
      body_height: hoehe,
      chest_pit_to_pit: num('chest_pit_to_pit'),
      konfektion: roh('konfektion'),
      long_size_history: roh('long_size_history'),
      collar_size: roh('collar_size'),
      collar_cm: num('collar_cm'),
      waistband: num('waistband')
    };
  }

  /* cm-Werte in die (ggf. Inch-)Felder schreiben: Profil-Restore und
     Einheitenwechsel mit erhaltenen Eingaben. */
  function schreibeFormWerte(form, werteCm, inch) {
    if (!werteCm) return;
    if (werteCm.body_height != null) {
      if (inch) {
        var fi = cmToFtIn(werteCm.body_height);
        if (fi && form['body_height_ft']) {
          form['body_height_ft'].value = fi.ft;
          if (form['body_height_in']) form['body_height_in'].value = fi.inch;
        }
      } else if (form['body_height']) {
        form['body_height'].value = werteCm.body_height;
      }
    }
    ['chest_pit_to_pit', 'collar_cm', 'waistband'].forEach(function (name) {
      if (werteCm[name] == null || !form[name]) return;
      form[name].value = inch ? cmToIn(werteCm[name], 1) : werteCm[name];
    });
    ['konfektion', 'collar_size', 'long_size_history'].forEach(function (name) {
      if (werteCm[name] != null && form[name]) form[name].value = werteCm[name];
    });
  }

  function applyStaticCopy(root, copy) {
    root.querySelectorAll('[data-size-advisor-copy]').forEach(function (el) {
      var key = el.getAttribute('data-size-advisor-copy');
      if (copy[key]) el.textContent = copy[key];
    });
  }

  /* ---------- Ergebnis rendern ---------- */

  /* Zahlformat: EN mit Punkt, alle anderen Locales mit Dezimalkomma (v1.8). */
  function fmtNum(v, locale) {
    if (v == null) return v;
    var s = String(v);
    return String(locale || '').toLowerCase() === 'en' ? s : s.replace('.', ',');
  }

  /* Skalen-Kurzlabel fuer den Trigger ("102 (Lang)"), am Profil gespeichert,
     damit das Label ohne Config-Load stimmt. */
  function mitSkalenLabel(rec, copy) {
    if (!rec || !rec.ok) return rec;
    rec.scaleLabel = null;
    if (!rec.lengthFallback && rec.mode !== 'shirt') {
      if (rec.lengthVariant === 'lang') rec.scaleLabel = copy.scale_short_lang || null;
      else if (rec.lengthVariant === 'untersetzt') rec.scaleLabel = copy.scale_short_untersetzt || null;
    }
    return rec;
  }

  /* Reine Textkomposition ohne DOM (v1.8): die exakten Kundentexte sind so
     in Node gegen die echte Config pruefbar. renderResult() traegt das
     Ergebnis nur noch ins DOM. ctx: family, familyKey, copy, locale,
     unitMode, variants. */
  function composeResult(ctx, rec) {
    var copy = ctx.copy, family = ctx.family, variants = ctx.variants || {};
    var locale = ctx.locale || 'de', familyKey = ctx.familyKey;
    var inch = ctx.unitMode === 'in';
    var ds = function (v) { return displaySize(familyKey, family, locale, v); };
    var fl = function (v) { return (v == null) ? v : (inch ? cmToIn(v, 1) : fmtNum(v, locale)); };
    var ck = function (k) { return (inch && copy[k + '_in']) ? copy[k + '_in'] : copy[k]; };
    var mode = family.input_mode || 'suit';
    var skala = function (linie, base) {
      if (linie === 'lang') return fill(ck('scale_lang'), { base: ds(base) });
      if (linie === 'untersetzt') return fill(ck('scale_untersetzt'), { base: ds(base) });
      return ck('scale_normal') || '';
    };
    var btn = function (size) {
      return { size: size, label: fill(ck('apply_label_size') || copy.apply_label || '{size}', { size: ds(size) }) };
    };

    if (!rec.ok) {
      var msg;
      if (rec.reason === 'missing_height') msg = copy.result_missing_height;
      else if (rec.reason === 'missing_length_history') msg = copy.result_missing_length_history;
      else if (rec.reason === 'length_uncertain') msg = mode === 'trousers' ? copy.result_length_uncertain_trousers
        : family.anzug_trouser_check ? copy.result_length_uncertain_suit : copy.result_length_uncertain_jacket;
      else if (rec.reason === 'missing_input') {
        msg = mode === 'shirt' ? ck('result_missing_input_shirt')
            : mode === 'trousers' ? ck('result_missing_input_trousers')
            : ck('result_missing_input_suit');
      } else if (rec.reason === 'ambiguous_chest') {
        msg = fill(ck('result_ambiguous_chest'), { size_a: ds(rec.sizeA), size_b: ds(rec.sizeB) });
      } else if (rec.reason === 'height_out_of_range') {
        msg = fill(ck('result_height_out_of_range'), { value: inch ? fmtHeight(rec.value) : rec.value });
      } else if (rec.reason === 'below_table' || rec.reason === 'above_table') {
        msg = fill(ck('result_' + rec.reason), { value: fl(rec.value), size: ds(rec.size), edge: fl(rec.edge) });
      } else if (rec.reason === 'implausible_chest' || rec.reason === 'implausible_waist' || rec.reason === 'implausible_collar') {
        msg = fill(ck('result_' + rec.reason), { value: fl(rec.value) });
      } else msg = copy.result_error_generic;
      return { kind: 'error', reason: rec.reason, text: msg || copy.result_error_generic, note: '', buttons: [] };
    }

    /* Haupt-Satz */
    var key;
    if (rec.mode === 'shirt') {
      key = rec.lengthVariant === 'lang' ? 'result_template_shirt_lang' : 'result_template_shirt_normal';
    } else if (rec.lengthFallback) {
      key = 'result_template_' + rec.lengthFallback;
    } else if (rec.lengthVariant === 'lang') {
      key = (rec.mode === 'trousers' && copy.result_template_trousers_lang) ? 'result_template_trousers_lang' : 'result_template_lang';
    } else if (rec.lengthVariant === 'untersetzt') {
      key = (rec.mode === 'trousers' && copy.result_template_trousers_untersetzt) ? 'result_template_trousers_untersetzt' : 'result_template_untersetzt';
    } else key = 'result_template_normal';
    var haupt = fill(ck(key), { size: ds(rec.size), base: ds(rec.baseSize || rec.size) });
    var notizen = [];

    var entry = entryBySize(family, rec.size);
    if (rec.mode === 'shirt' && entry) {
      if (entry.collar != null) notizen.push(fill(ck('result_measure_note_collar'), { collar: fl(entry.collar) }));
      if (entry.sleeve != null) notizen.push(fill(ck('result_measure_note_sleeve'), { sleeve: fl(entry.sleeve) }));
    }
    if (rec.mode === 'trousers') {
      if (rec.grenzfall) notizen.push(fill(ck('result_waist_between'), { size_down: ds(rec.grenzfall.down), size_up: ds(rec.grenzfall.up) }));
      else if (rec.source === 'waist') notizen.push(fill(ck('result_waist_range_note'), { size: ds(rec.size) }));
    } else if (rec.mode === 'suit' && !rec.upsizedFrom) {
      if (rec.grenzfall) {
        /* Zwischen zwei Groessen: der Kunde waehlt nach Vorliebe (Niels
           08.09.), Default bleibt die weitere. */
        notizen.push(fill(ck('result_chest_between'), { size_down: ds(rec.grenzfall.down), size_up: ds(rec.grenzfall.up) }));
        if (copy.note_shoulder_generous) notizen.push(fill(ck('note_shoulder_generous'), { size_down: ds(rec.grenzfall.down) }));
      } else if (rec.edge === 'wider' && copy.result_chest_edge_wider) {
        notizen.push(fill(ck('result_chest_edge_wider'), { size: ds(rec.size) }));
      } else if (rec.source === 'chest') {
        /* Keine Zentimeter-Praezision vortaeuschen: eine Groesse deckt einen
           Bereich ab (Niels: "+-1 cm an der Brust ist voll easy"). */
        notizen.push(fill(ck('result_chest_range_note'), { size: ds(rec.size) }));
      }
    }
    if (rec.mode === 'shirt' && rec.source === 'chest' && rec.measureDiff != null) {
      notizen.push(fill(ck('result_chest_match_note'),
        { diff: inch ? cmToIn(rec.measureDiff, 1) : fmtNum(rec.measureDiff.toFixed(1), locale) }));
    }

    /* Anzug: Bund-Befund. Gehoert immer zur Groesse, die am Ende genannt
       wird (bei Alternativen also zur Alternative). */
    var bundNotiz = function (wc, groesse, von) {
      if (!wc) return null;
      if (wc.status === 'implausible') return fill(ck('result_implausible_waist'), { value: fl(wc.user) });
      var k = { fit: 'result_anzug_waist_fit', tight: 'result_anzug_waist_tight', upsize: 'result_anzug_waist_upsize',
                beyond: 'result_anzug_waist_beyond', wide: 'result_anzug_waist_wide', check: 'result_anzug_waist_check' }[wc.status];
      /* Nachmessen in der Weiter-Richtung: mit der Konsequenz, falls der Wert
         stimmt (Niels 08.09.: dann faellt die Hose weit aus, enger machen). */
      if (wc.status === 'check' && wc.user < wc.waistband && copy.result_anzug_waist_check_wide) k = 'result_anzug_waist_check_wide';
      if (!k || !copy[k]) return null;
      return fill(ck(k), { size: ds(groesse), delta: fl(wc.delta), waist: fl(wc.waistband), user: fl(wc.user),
                           up: wc.up ? ds(wc.up) : '', from: von ? ds(von) : '' });
    };
    var bundText = (rec.mode === 'suit' && rec.waistCheck)
      ? bundNotiz(rec.waistCheck, rec.upsizedFrom || rec.size, rec.upsizedFrom) : null;

    var buttons = [btn(rec.size)];
    if (rec.mode === 'suit' && rec.upsizedFrom && isAvailable(variants, rec.upsizedFrom)) buttons.push(btn(rec.upsizedFrom));
    if (rec.mode === 'suit' && rec.grenzfall && !rec.upsizedFrom && isAvailable(variants, rec.grenzfall.down)) buttons.push(btn(rec.grenzfall.down));

    /* Verfuegbarkeit */
    var verfuegbar = isAvailable(variants, rec.size);
    var text = haupt;
    var alts = [];
    var altTexte = [];
    if (!verfuegbar && rec.upsizedFrom && isAvailable(variants, rec.upsizedFrom)) {
      /* Hochgestufte Groesse ausverkauft, die kleinere lieferbar: der
         Bund-Hinweis erklaert bereits, wann die kleinere passt. */
      return {
        kind: 'ok', text: fill(ck('result_unavailable'), { size: ds(rec.size) }) + ' ' + haupt,
        note: notizen.concat(bundText ? [bundText] : []).join(' '), buttons: [btn(rec.upsizedFrom)],
        recommendedSize: rec.size, targetSize: rec.upsizedFrom, available: false, substituted: true,
        waistStatus: rec.waistCheck ? rec.waistCheck.status : null,
        waistDelta: rec.waistCheck ? rec.waistCheck.delta : null
      };
    }
    if (!verfuegbar) {
      alts = findAlternatives(family, rec, variants);
      if (!alts.length) {
        /* Sackgasse: kein Bund-Hinweis, er lenkt hier nur ab. */
        return { kind: 'deadend', text: fill(ck('result_unavailable_final'), { size: ds(rec.size) }),
                 note: notizen.join(' '), buttons: [], recommendedSize: rec.size,
                 waistStatus: rec.waistCheck ? rec.waistCheck.status : null };
      }
      text = fill(ck('result_unavailable'), { size: ds(rec.size) }) + ' ' + haupt;
      buttons = [];
      alts.forEach(function (alt, i) {
        var s = skala(alt.line, alt.base);
        if (rec.mode === 'trousers') {
          var desc;
          if (alt.kind === 'size_up') {
            desc = (alt.waistDeltaUser != null)
              ? fill(ck('alt_desc_size_up_measured'), { delta: fl(Math.abs(alt.waistDeltaUser)) })
              : fill(ck('alt_desc_size_up_table'), { delta: fl(Math.abs(alt.waistDelta || 0)), orig: ds(rec.size) });
          } else if (alt.inseamDelta > 0) desc = fill(ck('alt_desc_leg_longer'), { scale: s, inseam: fl(Math.abs(alt.inseamDelta)) });
          else if (alt.inseamDelta < 0) desc = fill(ck('alt_desc_leg_shorter'), { scale: s, inseam: fl(Math.abs(alt.inseamDelta)) });
          else desc = fill(ck('alt_desc_leg_same'), { scale: s });
          var wrapKey = alts.length === 1 ? 'result_alt_only' : (i === 0 ? 'result_alt_first' : 'result_alt_second');
          altTexte.push(fill(ck(wrapKey), { alt: ds(alt.size), desc: desc }));
        } else if (rec.mode === 'shirt') {
          var sk = (alt.sleeveDelta != null && alt.sleeveDelta < 0) ? 'result_alt_shorter_sleeve' : 'result_alt_longer_sleeve';
          altTexte.push(fill(ck(sk), { alt: ds(alt.size), delta: fl(Math.abs(alt.sleeveDelta || 0)) }));
        } else {
          var ref = alt.backDelta != null ? alt.backDelta : alt.sleeveDelta;
          var ak = (ref != null && ref < 0) ? 'result_alt_suit_shorter' : 'result_alt_suit_longer';
          altTexte.push(fill(ck(ak), { alt: ds(alt.size), scale: s,
            back: fl(Math.abs(alt.backDelta || 0)), sleeve: fl(Math.abs(alt.sleeveDelta || 0)) }));
          if (alt.waistCheck) {
            var wcAlt = alt.waistCheck;
            if (wcAlt.status === 'upsize') {
              wcAlt = { status: 'beyond', delta: wcAlt.delta, waistband: wcAlt.waistband, user: wcAlt.user, up: null };
            }
            var an = bundNotiz(wcAlt, alt.size, null);
            if (an) altTexte.push(an);
          }
        }
        buttons.push(btn(alt.size));
      });
    }

    var alleNotizen = notizen.slice();
    if (alts.length) alleNotizen = alleNotizen.concat(altTexte);
    else if (bundText) alleNotizen.push(bundText);

    return {
      kind: 'ok', text: text, note: alleNotizen.join(' '), buttons: buttons,
      recommendedSize: rec.size, targetSize: buttons.length ? buttons[0].size : rec.size,
      available: verfuegbar, substituted: alts.length > 0,
      waistStatus: rec.waistCheck ? rec.waistCheck.status : null,
      waistDelta: rec.waistCheck ? rec.waistCheck.delta : null
    };
  }

  function renderResult(ctx, rec, fromProfile) {
    var root = ctx.root;
    /* Fuer den Re-Render beim Einheitenwechsel merken (v1.7). */
    ctx.lastRec = rec;
    ctx.locale = root.dataset.locale;
    ctx.unitMode = root.dataset.unitMode;
    ctx.familyKey = root.dataset.family;
    var out = composeResult(ctx, rec);

    var box = root.querySelector('[data-size-advisor-result]');
    var textEl = root.querySelector('[data-size-advisor-result-text]');
    var noteEl = root.querySelector('[data-size-advisor-result-note]');
    var actions = root.querySelector('[data-size-advisor-result-actions]');
    var applyBtns = [root.querySelector('[data-size-advisor-apply]'), root.querySelector('[data-size-advisor-apply-alt]')];
    var stored = root.querySelector('[data-size-advisor-stored-notice]');
    var basis = { product_handle: root.dataset.productHandle, family: root.dataset.family };

    stored.hidden = true;
    textEl.textContent = out.text;
    noteEl.textContent = out.note;

    if (out.kind === 'error') {
      actions.hidden = true;
      box.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      if (!ctx.skipTracking) trackEvent('no_recommendation', { product_handle: basis.product_handle, family: basis.family, reason: out.reason });
      return;
    }
    /* Eine gelesene Empfehlung zaehlt auch ohne Uebernehmen-Klick. */
    markiereWarenkorb(root, ctx.familyKey, out.recommendedSize, null,
      out.waistStatus ? out.waistStatus + ':' + out.waistDelta : '');
    markiereNutzung();
    if (out.kind === 'deadend') {
      actions.hidden = true;
      box.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      if (!ctx.skipTracking) trackEvent('recommend_unavailable', { product_handle: basis.product_handle, family: basis.family, recommended_size: out.recommendedSize });
      return;
    }

    /* Knoepfe: jeder nennt seine Groesse (Niels/Codex 08.09.), kein stiller
       Austausch hinter einem allgemeinen Label. */
    var waistMarker = out.waistStatus ? (out.waistStatus + ':' + out.waistDelta) : '';
    applyBtns.forEach(function (b, i) {
      if (!b) return;
      var def = out.buttons[i];
      if (!def) { b.hidden = true; return; }
      b.hidden = false;
      b.disabled = false;
      b.textContent = def.label;
      b.dataset.label = def.label;
      b.dataset.targetSize = def.size;
      b.dataset.recommendedSize = out.recommendedSize;
      b.dataset.waistStatus = waistMarker;
    });

    actions.hidden = false;
    box.hidden = false;
    if (!fromProfile) box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    if (!ctx.skipTracking) trackEvent(fromProfile ? 'recommend_from_profile' : 'recommend', {
      product_handle: basis.product_handle,
      family: basis.family,
      recommended_size: out.recommendedSize,
      applied_size: out.targetSize,
      length_variant: rec.lengthVariant,
      length_fallback: rec.lengthFallback || null,
      source: rec.source,
      available: out.available,
      substituted: out.substituted,
      upsized: !!rec.upsizedFrom,
      waist_status: out.waistStatus,
      waist_delta: out.waistDelta
    });
  }

  /* ---------- Zustaende ---------- */

  function showFreshState(root) {
    var banner = root.querySelector('[data-size-advisor-returning]');
    var intro = root.querySelector('[data-size-advisor-intro]');
    var form = root.querySelector('[data-size-advisor-form]');
    var result = root.querySelector('[data-size-advisor-result]');
    if (banner) banner.hidden = true;
    if (intro) intro.hidden = false;
    if (form) form.hidden = false;
    if (result) result.hidden = true;
  }

  function showReturningState(root) {
    var banner = root.querySelector('[data-size-advisor-returning]');
    var intro = root.querySelector('[data-size-advisor-intro]');
    var form = root.querySelector('[data-size-advisor-form]');
    if (banner) banner.hidden = false;
    if (intro) intro.hidden = true;
    if (form) form.hidden = true;
  }

  function renderReturningBanner(root, profile, copy, family) {
    var list = root.querySelector('[data-size-advisor-inputs-list]');
    if (!list || !profile || !profile.input) return;
    list.innerHTML = '';
    /* Profil-Werte sind cm-kanonisch (seit v1.7 explizit); im Inch-Modus
       konvertiert die Anzeige. Konfektion = Groessenwert -> auf EN dual. */
    var inch = root.dataset.unitMode === 'in';
    var fl = function (v) { return (inch && v != null) ? cmToIn(v, 1) : v; };
    var ck = function (k) { return (inch && copy[k + '_in']) ? copy[k + '_in'] : copy[k]; };
    var konf = profile.input.konfektion != null && profile.input.konfektion !== ''
      ? displaySize(root.dataset.family, family, root.dataset.locale, profile.input.konfektion)
      : profile.input.konfektion;
    var hoehe = profile.input.body_height;
    if (hoehe != null && hoehe !== '' && inch) hoehe = fmtHeight(hoehe);
    [['returning_input_height', hoehe],
     ['returning_input_collar_size', profile.input.collar_size],
     ['returning_input_collar_cm', fl(profile.input.collar_cm)],
     ['returning_input_chest', fl(profile.input.chest_pit_to_pit)],
     ['returning_input_konfektion', konf],
     ['returning_input_waistband', fl(profile.input.waistband)]].forEach(function (paar) {
      if (paar[1] == null || paar[1] === '') return;
      var li = document.createElement('li');
      li.textContent = fill(ck(paar[0]), { value: paar[1] });
      list.appendChild(li);
    });
  }

  function fillFormFromProfile(form, profile, inch) {
    if (!profile || !profile.input) return;
    /* Profil ist cm-kanonisch; schreibeFormWerte konvertiert fuer Inch-Felder. */
    schreibeFormWerte(form, profile.input, !!inch);
    /* "merken" bewusst NICHT auto-anhaken: bei jeder Aenderung neu zustimmen. */
  }

  /* ---------- Trigger-Label (ohne Config) ---------- */

  function triggerI18n(root) {
    var el = root.querySelector('[data-size-advisor-trigger-i18n]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function updateTriggerLabel(root, profile, i18n) {
    var labelEl = root.querySelector('[data-size-advisor-trigger-label]');
    var hintEl = root.querySelector('[data-size-advisor-trigger-hint]');
    if (!labelEl) return;
    if (profile && profile.version === ADVISOR_VERSION && profile.recommendation && profile.recommendation.size) {
      /* Vor dem Lazy-Load gibt es keine Config: Sakko/Anzug konvertiert die
         Formel trotzdem, Hose faellt auf "EU <n>" zurueck - beides eindeutig.
         Das Skalen-Label ("102 (Lang)") haengt seit v1.8 am Profil. */
      var anzeige = displaySize(root.dataset.family, null, root.dataset.locale, profile.recommendation.size);
      if (profile.recommendation.scaleLabel) anzeige += ' (' + profile.recommendation.scaleLabel + ')';
      labelEl.textContent = fill(i18n.trigger_label_returning, { size: anzeige });
      if (hintEl) hintEl.textContent = i18n.trigger_hint_returning || '';
    } else {
      labelEl.textContent = i18n.trigger_label || labelEl.textContent;
      if (hintEl) hintEl.textContent = i18n.trigger_hint_first || '';
    }
  }

  /* ---------- Varianten-Map ---------- */

  function getVariantsMap(root) {
    var el = root.querySelector('[data-size-advisor-variants]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  /* ---------- Init ---------- */

  function initInstance(root) {
    var familyKey = root.dataset.family;
    var locale = root.dataset.locale || 'de'; // Fallback auf DE erledigt der Config-Lookup
    var i18n = triggerI18n(root);
    var profile = loadProfile(familyKey);
    var trigger = root.querySelector('[data-size-advisor-trigger]');
    var panel = root.querySelector('[data-size-advisor-panel]');
    if (!trigger || !panel) return;

    updateTriggerLabel(root, profile, i18n);

    var ctx = null;          /* wird beim ersten Oeffnen gefuellt */
    var ladend = false;

    function panelOeffnen() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (profile && profile.recommendation) {
        /* v1.8: die gespeicherte Empfehlung aus den Eingaben neu rechnen,
           damit ein Regel- oder Tabellenwechsel nicht mit alten Groessen
           weiterlebt. Fehlschlag (z. B. Eingabe inzwischen unplausibel):
           das alte Ergebnis bleibt sichtbar, der Kunde kann neu rechnen. */
        var neu = profile.input ? recommend(ctx.family, profile.input) : null;
        if (!neu || !neu.ok) {
          showFreshState(root);
          fillFormFromProfile(root.querySelector('[data-size-advisor-form]'), profile, root.dataset.unitMode === 'in');
          zeigeLaengenfrage(root, ctx.family);
          if (neu) renderResult(ctx, neu, true);
          return;
        }
        if (neu && neu.ok) {
          profile.recommendation = mitSkalenLabel(neu, ctx.copy);
          profile.version = ADVISOR_VERSION;
          saveProfile(familyKey, profile);
          updateTriggerLabel(root, profile, i18n);
        }
        showReturningState(root);
        fillFormFromProfile(root.querySelector('[data-size-advisor-form]'), profile,
          root.dataset.unitMode === 'in');
        zeigeLaengenfrage(root, ctx.family);
        renderReturningBanner(root, profile, ctx.copy, ctx.family);
        renderResult(ctx, profile.recommendation, true);
        trackEvent('open_returning', { product_handle: root.dataset.productHandle, family: familyKey });
      } else {
        showFreshState(root);
        trackEvent('open', { product_handle: root.dataset.productHandle, family: familyKey });
      }
    }

    function aufbauen(config) {
      var family = config.families[familyKey];
      if (!family) throw new Error('Size Advisor: Family unbekannt: ' + familyKey);
      var copy = (config.ui.copy && config.ui.copy[locale]) || config.ui.copy.de;
      setPlausibility(config.ui.plausibility);
      setAltBands(config.ui.alternative_height_bands);

      ctx = { root: root, family: family, copy: copy, variants: getVariantsMap(root) };

      /* Einheiten-Modus festlegen (v1.7): nur EN, sonst hart cm. */
      root.dataset.unitMode = unitModeFuer(root);

      buildFields(root, family, config.ui, copy, root.dataset.productId || 'x', einheitWechseln);
      applyStaticCopy(root, copy);

      /* Einheitenwechsel: Eingaben cm-kanonisch retten, Felder neu bauen,
         Werte zurueckschreiben, sichtbares Ergebnis neu rendern (ohne
         Tracking-Doppel). Function declaration - hoisted, buildFields oben
         bekommt die Referenz. */
      function einheitWechseln(neu) {
        if (neu === root.dataset.unitMode) return;
        var werteCm = leseWerteCm(form, root.dataset.unitMode === 'in');
        root.dataset.unitMode = neu;
        try { localStorage.setItem(UNITS_KEY, neu); } catch (e) {}
        buildFields(root, family, config.ui, copy, root.dataset.productId || 'x', einheitWechseln);
        schreibeFormWerte(form, werteCm, neu === 'in');
        zeigeLaengenfrage(root, family);
        if (profile && profile.recommendation) renderReturningBanner(root, profile, copy, family);
        var resBox = root.querySelector('[data-size-advisor-result]');
        if (ctx && ctx.lastRec && resBox && !resBox.hidden) {
          ctx.skipTracking = true;
          renderResult(ctx, ctx.lastRec, true);
          ctx.skipTracking = false;
        }
      }

      var introEl = root.querySelector('[data-size-advisor-intro]');
      if (introEl) {
        introEl.textContent = family.input_mode === 'shirt' ? copy.intro_shirt
          : family.input_mode === 'trousers' ? copy.intro_trousers : copy.intro_suit;
      }

      var form = root.querySelector('[data-size-advisor-form]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        /* v1.7: Werte einheiten-normalisiert einsammeln - input ist IMMER cm,
           recommend() und das Profil bleiben davon unberuehrt. */
        var inchModus = root.dataset.unitMode === 'in';
        var input = leseWerteCm(form, inchModus);
        var merken = !!(form.remember && form.remember.checked);
        var rec = mitSkalenLabel(recommend(family, input), copy);
        renderResult(ctx, rec, false);

        if (rec.ok && merken) {
          var ok = saveProfile(familyKey, {
            input: input, recommendation: rec, units: inchModus ? 'in' : 'cm',
            version: ADVISOR_VERSION, saved_at: new Date().toISOString()
          });
          if (ok) {
            profile = loadProfile(familyKey);
            updateTriggerLabel(root, profile, i18n);
            var stored = root.querySelector('[data-size-advisor-stored-notice]');
            if (stored) stored.hidden = false;
            trackEvent('profile_saved', { product_handle: root.dataset.productHandle, family: familyKey });
          }
        } else if (rec.ok && !merken && loadProfile(familyKey)) {
          /* Ohne Haken kein Altbestand: sonst widersprechen sich alte und neue Empfehlung. */
          clearProfile(familyKey);
          profile = null;
          updateTriggerLabel(root, profile, i18n);
        }
      });

      /* Zwei Uebernehmen-Knoepfe (v1.8): Grenzfall, hochgestufte Groesse
         oder zwei Hosen-Alternativen. Jeder Knopf nennt seine Groesse. */
      var noteEl = root.querySelector('[data-size-advisor-result-note]');
      var applyBtns = [root.querySelector('[data-size-advisor-apply]'), root.querySelector('[data-size-advisor-apply-alt]')];
      applyBtns.forEach(function (applyBtn) {
        if (!applyBtn) return;
        applyBtn.addEventListener('click', function () {
          var size = applyBtn.dataset.targetSize;
          if (!size) return;
          var res = preSelectVariant(root, size);
          trackEvent('apply', {
            product_handle: root.dataset.productHandle,
            applied_size: size,
            preselect_ok: res.ok,
            preselect_reason: res.reason
          });
          if (res.ok) {
            markiereWarenkorb(root, familyKey, applyBtn.dataset.recommendedSize || size, size, applyBtn.dataset.waistStatus);
            applyBtn.textContent = fill(copy.apply_done, { size: displaySize(familyKey, family, locale, size) });
            applyBtn.disabled = true;
            /* Der andere Knopf bleibt waehlbar: umentscheiden geht. */
            applyBtns.forEach(function (o) {
              if (o && o !== applyBtn && !o.hidden) { o.disabled = false; o.textContent = o.dataset.label || o.textContent; }
            });
          } else if (noteEl) {
            /* Nicht stumm scheitern: der Kunde hat geklickt und muss sehen, warum
               sich oben nichts bewegt. */
            var key = res.reason === 'in_dieser_farbe_nicht_waehlbar'
              ? 'apply_failed_color' : 'apply_failed';
            noteEl.textContent = fill(copy[key], { size: displaySize(familyKey, family, locale, size) });
          }
        });
      });

      var resetBtn = root.querySelector('[data-size-advisor-reset]');
      if (resetBtn) resetBtn.addEventListener('click', function () {
        form.reset();
        zeigeLaengenfrage(root, family);
        root.querySelector('[data-size-advisor-result]').hidden = true;
        showFreshState(root);
      });

      var resetProminent = root.querySelector('[data-size-advisor-reset-prominent]');
      if (resetProminent) resetProminent.addEventListener('click', function () {
        clearProfile(familyKey);
        profile = null;
        updateTriggerLabel(root, profile, i18n);
        form.reset();
        zeigeLaengenfrage(root, family);
        showFreshState(root);
        trackEvent('reset', { product_handle: root.dataset.productHandle, family: familyKey });
      });

      var editBtn = root.querySelector('[data-size-advisor-edit]');
      if (editBtn) editBtn.addEventListener('click', function () { showFreshState(root); });
    }

    trigger.addEventListener('click', function () {
      if (!panel.hidden) {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        return;
      }
      if (ctx) { panelOeffnen(); return; }
      if (ladend) return;
      ladend = true;
      trigger.classList.add('is-loading');
      loadConfig(root.dataset.configUrl)
        .then(function (config) { aufbauen(config); panelOeffnen(); })
        .catch(function (err) {
          console.error('Size Advisor: Init fehlgeschlagen', err);
          /* Fail-visible: der Berater verschwindet, statt einen toten Button
             stehen zu lassen. Die Groessentabelle im Modal bleibt erreichbar. */
          root.hidden = true;
        })
        .then(function () { ladend = false; trigger.classList.remove('is-loading'); });
    });
  }

  function initAll() {
    if (document.querySelector('[data-size-advisor]')) {
      document.addEventListener('cart:change', function (event) {
        pruefeWarenkorbMarkierung(event.detail && event.detail.cart);
      });
      /* Vorheriger Seitenbesuch: nur bestehende Warenkorbmerkmale lesen,
         keine zusaetzliche Browser-Speicherung. */
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(pruefeWarenkorbMarkierung)
        .catch(function () { /* Positionsmarker bleibt unabhaengig davon nutzbar. */ });
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-size-advisor]'), initInstance);
  }

  /* Der DOM-Teil laeuft nur im Browser. Ohne document (Node) wird die Datei
     nur geladen, damit die Rechenlogik gegen die echte Config testbar bleibt. */
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      recommend: recommend,
      findAlternative: findAlternative,
      findAlternatives: findAlternatives,
      composeResult: composeResult,
      pruefeBund: pruefeBund,
      waehleWeite: waehleWeite,
      linieFuer: linieFuer,
      basisGroesse: basisGroesse,
      mitSkalenLabel: mitSkalenLabel,
      fmtNum: fmtNum,
      displaySize: displaySize,
      inToCm: inToCm,
      cmToIn: cmToIn,
      ftInToCm: ftInToCm,
      cmToFtIn: cmToFtIn,
      fmtHeight: fmtHeight,
      leseWerteCm: leseWerteCm,
      schreibeFormWerte: schreibeFormWerte,
      lengthCategory: lengthCategory,
      entryBySize: entryBySize,
      scaleOf: scaleOf,
      nachbarGroesse: nachbarGroesse,
      laengenwechselErlaubt: laengenwechselErlaubt,
      setPlausibility: setPlausibility,
      setAltBands: setAltBands,
      SHIRT_LANG_MIN_CM: SHIRT_LANG_MIN_CM,
      ADVISOR_VERSION: ADVISOR_VERSION
    };
  }
})();
